<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-contact-hero-section />
  <!-- Form -->
  <app-contact-form-section />
  <!-- Methods -->
  <app-contact-methods-section />
  <!-- Newsletter -->
  <app-newsletter-section />
</div>
